module.exports = __webpack_public_path__ + "img/tablet.85c1dc02.svg";